import { render, staticRenderFns } from "./rolePromission.vue?vue&type=template&id=17a8a6dc&scoped=true"
import script from "./rolePromission.vue?vue&type=script&lang=js"
export * from "./rolePromission.vue?vue&type=script&lang=js"
import style0 from "./rolePromission.vue?vue&type=style&index=0&id=17a8a6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a8a6dc",
  null
  
)

export default component.exports